module.exports = __webpack_public_path__ + "static/img/1019_big.0a504f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1019_big.png
// module id = HYK5
// module chunks = 1